import { useNavigate } from "react-router-dom";
import { coachPaths } from "../routes/coach";
import { enterPrisesPaths } from "../routes/enterprises";


const CoachLayout = ({ children, user }) => {
  const navigate = useNavigate();
  return (
    <>
      <div class="text-end py-4 ">
        {/* <div className="ct_navbar ">
        <ul className="justify-content-end pe-4">
          <li>
            <a onClick={()=> navigate(coachPaths?.AboutUs)}>About Us</a>
          </li>
          <li>
            <a onClick={()=> navigate(coachPaths?.ContactUs)}>Contact Us</a>
          </li>
        </ul>
        </div> */}
        <div class="ct_logo">
          <a
            onClick={() => {
              navigate(enterPrisesPaths?.Enterprise);
            }}
          >
            <img
              src="/assets/img/Nuvio_logo.png"
              alt=""
            />
          </a>
        </div>
      </div>
      {children}
    </>
  );
};

export default CoachLayout;
